import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { CheckCircle2, Phone } from 'lucide-react';
export function VanityInstallationPage() {
  return <div className="flex flex-col min-h-screen pt-24 pb-20" data-id="element-580">
      {/* Hero */}
      <section className="relative bg-gray-50 py-16 md:py-24 overflow-hidden" data-id="element-581">
        <div className="absolute inset-0 z-0" data-id="element-582">
          <img src="https://cdn.magicpatterns.com/uploads/ayb9hFKTK1m7L1LouYMMgd/bathroom-vanity.jpg" alt="Vanity installation" className="w-full h-full object-cover object-center" data-id="element-583" />
          <div className="absolute inset-0 bg-white/85" data-id="element-584"></div>
        </div>

        <div className="container relative z-10 mx-auto px-4 md:px-6" data-id="element-585">
          <div className="max-w-3xl mx-auto text-center" data-id="element-586">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-587">
              Vanity Installation Services in Northern Indiana
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed mb-8" data-id="element-588">
              Professional bathroom vanity installation and replacement
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-589">
              <Link to="/contact" data-id="element-590">
                <Button size="lg" data-id="element-591">Get Free Consultation</Button>
              </Link>
              <Button variant="outline" size="lg" data-id="element-592">
                <Phone className="mr-2 h-5 w-5" data-id="element-593" />
                (574) 914-1522
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16" data-id="element-594">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-595">
          <div className="prose prose-lg max-w-none" data-id="element-596">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-597">
              Expert Vanity Installation and Replacement
            </h2>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-598">
              Your bathroom vanity is more than just a functional necessity—it's
              a central design element that sets the tone for your entire
              bathroom. Lucky Duck Bathroom Company provides professional vanity
              installation services throughout Northern Indiana, helping
              homeowners upgrade their bathrooms with beautiful, functional
              vanities that enhance both style and storage. Whether you're
              replacing an outdated vanity or installing a new one as part of a
              larger remodel, we deliver quality results that last.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-599">
              Our Vanity Installation Services
            </h3>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-600">
              We handle every aspect of vanity installation, from removing your
              old vanity and preparing the space to installing new plumbing
              connections and ensuring perfect alignment. Our comprehensive
              service includes disconnecting and removing existing vanities,
              preparing walls and floors, installing new vanities with proper
              leveling and anchoring, connecting plumbing fixtures and drains,
              installing countertops and sinks, mounting mirrors and lighting,
              and adding hardware and accessories.
            </p>

            <div className="bg-gray-50 p-6 rounded-lg mb-6" data-id="element-601">
              <h4 className="text-xl font-bold text-gray-900 mb-4" data-id="element-602">
                Vanity Styles We Install:
              </h4>
              <ul className="space-y-3" data-id="element-603">
                {['Single sink vanities - perfect for smaller bathrooms', 'Double sink vanities - ideal for master bathrooms', 'Floating vanities - modern, space-saving design', 'Freestanding vanities - traditional elegance', 'Custom vanities - built to your exact specifications', 'Vessel sink vanities - contemporary style statement'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-604">
                    <CheckCircle2 className="h-6 w-6 text-[#8BA888] shrink-0 mt-0.5" data-id="element-605" />
                    <span className="text-gray-700" data-id="element-606">{item}</span>
                  </li>)}
              </ul>
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-607">
              Choosing the Right Vanity for Your Bathroom
            </h3>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-608">
              Selecting the perfect vanity involves balancing style, size,
              storage needs, and budget. Consider your bathroom dimensions and
              layout—a vanity should fit comfortably without overwhelming the
              space or blocking doorways. Think about storage requirements: do
              you need drawers for organizing toiletries, open shelving for
              towels, or a combination of both?
            </p>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-609">
              Material choices affect both appearance and durability. Solid wood
              vanities offer timeless beauty and longevity, while engineered
              wood options provide good value with moisture-resistant
              properties. Countertop materials range from affordable laminate to
              luxurious granite, quartz, or marble. We help you navigate these
              options to find the best fit for your needs and budget.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-610">
              Professional Installation Makes the Difference
            </h3>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-611">
              Proper vanity installation requires precision and expertise. The
              vanity must be perfectly level to prevent water pooling and ensure
              doors and drawers operate smoothly. Plumbing connections need
              proper sealing to prevent leaks. Wall anchoring must be secure,
              especially for floating vanities that bear significant weight.
              These details separate professional installations from DIY
              attempts that often lead to problems down the road.
            </p>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-612">
              Our experienced team handles unexpected challenges that commonly
              arise during vanity replacements, such as outdated plumbing that
              needs updating, wall damage that requires repair, or floor
              leveling issues. We come prepared with the tools, materials, and
              knowledge to address these situations efficiently, keeping your
              project on track.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-613">
              Coordinating Your Vanity with Overall Bathroom Design
            </h3>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-614">
              Your vanity should complement your bathroom's overall aesthetic.
              We can help coordinate finishes, colors, and styles with your
              existing fixtures, flooring, and wall treatments—or plan a
              cohesive design if you're updating multiple elements. From modern
              minimalist to classic traditional, rustic farmhouse to
              contemporary spa-inspired, we work with all design styles to
              create a harmonious, beautiful bathroom.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-615">
              Why Choose Lucky Duck for Vanity Installation?
            </h3>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-616">
              As a family-owned business serving Northern Indiana, we bring
              local expertise and personalized service to every project. We
              understand the importance of quality workmanship and attention to
              detail. Our team treats your home with respect, protects
              surrounding areas during installation, and cleans up thoroughly
              when the job is complete.
            </p>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-617">
              We serve South Bend, Mishawaka, Elkhart, Goshen, Granger, and
              surrounding communities with honest pricing, reliable scheduling,
              and the craftsmanship you deserve. Whether you're updating a
              powder room or transforming a master bathroom, we're committed to
              exceeding your expectations.
            </p>

            <div className="bg-[#8BA888]/10 border-l-4 border-[#8BA888] p-6 rounded-r-lg mt-8" data-id="element-618">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-619">
                Ready to Upgrade Your Bathroom Vanity?
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-620">
                Contact Lucky Duck Bathroom Company today for a free
                consultation and let's discuss the perfect vanity for your
                bathroom.
              </p>
              <Link to="/contact" data-id="element-621">
                <Button size="lg" data-id="element-622">Schedule Free Consultation</Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
}